module.exports = __webpack_public_path__ + "static/img/sx_light.0881cd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/sx_light.png
// module id = t71T
// module chunks = 1